import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  border-radius: inherit;\n  transform: translate3d(0, 0, 0); // Workaround for iOS safari bug\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { backdropDarkGradient, backdropFullGradient, backdropLightGradient, blackBackdropDarkGradient, blackBackdropFullGradient, blackBackdropGradient, bttGradient, ltrGradient, rtlGradient, ttbGradient, whiteBackdropDarkGradient, whiteBackdropGradient, whiteBackdropLightGradient } from '../helpers/gradients';
import { heightMixin, widthMixin, zIndexMixin } from '../mixins/layout';
import { userSelectNoneStyle } from '../tokens/user-select';
import { pointerEventsNoneStyle } from '../tokens/pointer-events';
import { styleForBreakpoints } from '../helpers/media-style';
var gradients = {
  bottom: ttbGradient,
  top: bttGradient,
  left: rtlGradient,
  right: ltrGradient
};
var Wrapper = styled.div(_templateObject(), function (_ref) {
  var $position = _ref.$position;
  return styleForBreakpoints($position, function ($position) {
    return (
      /* prettier-ignore */
      $position === 'bottom' ? "\n          left: 0;\n          right: 0;\n          bottom: 0;\n        " : $position === 'top' ? "\n          left: 0;\n          right: 0;\n          top: 0;\n        " : $position === 'left' ? "\n          top: 0;\n          bottom: 0;\n          left: 0;\n        " : $position === 'right' ? "\n          top: 0;\n          bottom: 0;\n          right: 0;\n        " : ''
    );
  });
}, function (_ref2) {
  var $position = _ref2.$position,
      $gradientColor = _ref2.$gradientColor;
  return styleForBreakpoints($position, function ($position) {
    return gradients[$position]($gradientColor);
  });
}, zIndexMixin, heightMixin, widthMixin, pointerEventsNoneStyle, userSelectNoneStyle);

var Backdrop = function Backdrop(_ref3) {
  var _ref3$inverse = _ref3.inverse,
      inverse = _ref3$inverse === void 0 ? false : _ref3$inverse,
      _ref3$full = _ref3.full,
      full = _ref3$full === void 0 ? false : _ref3$full,
      _ref3$light = _ref3.light,
      light = _ref3$light === void 0 ? false : _ref3$light,
      _ref3$dark = _ref3.dark,
      dark = _ref3$dark === void 0 ? false : _ref3$dark,
      _ref3$position = _ref3.position,
      position = _ref3$position === void 0 ? 'bottom' : _ref3$position,
      r = _ref3.r,
      g = _ref3.g,
      b = _ref3.b,
      width = _ref3.width,
      height = _ref3.height,
      zIndex = _ref3.zIndex,
      props = _objectWithoutPropertiesLoose(_ref3, ["inverse", "full", "light", "dark", "position", "r", "g", "b", "width", "height", "zIndex"]);

  var gradientColor = r && g && b ? full ? backdropFullGradient(r, g, b) : dark ? backdropDarkGradient(r, g, b) : backdropLightGradient(r, g, b) : inverse ? light ? whiteBackdropLightGradient : dark ? whiteBackdropDarkGradient : whiteBackdropGradient : full ? blackBackdropFullGradient : dark ? blackBackdropDarkGradient : blackBackdropGradient;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $zIndex: zIndex,
    $gradientColor: gradientColor,
    $position: position,
    $width: width,
    $height: height
  }, props));
};

export default Backdrop;